import { validateEmail } from '../../common';
import { isNotIncludedEmailDomain } from '../../utils';
export const proffitSearchAccountBillingInformationValidate = {
    email: [
        ...validateEmail,
        (value, record, props) => {
            const { initialValues } = props;
            const { billingInformation } = initialValues || {};
            return billingInformation &&
                billingInformation.filter((v) => v.email === value).length > 1
                ? '既に登録されているメールアドレスです'
                : '';
        },
        (value, record) => {
            const { billingInformation } = record;
            return billingInformation &&
                billingInformation.filter((v) => v.email === value).length > 1
                ? '同じメールアドレスが入力されています'
                : '';
        },
        (value, record, props) => {
            const { admin } = props;
            if (admin) {
                // アカウント一覧の請求書送付先バリデーション
                const { email } = admin;
                return email && email === value
                    ? '既に請求責任者として登録済みです'
                    : '';
            }
            // メンバー追加の請求書送付先バリデーション
            const { admin: email } = record;
            return email && email === value
                ? '請求責任者に同じメールアドレスが入力されています'
                : '';
        },
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
    ],
};
export default proffitSearchAccountBillingInformationValidate;
